export default "__VITE_ASSET__EcS$moo9__"